"use client";
import { useState } from "react";
import { useCandidateProfileStore } from "../../store/useCandidateProfileStore";
import { useResumeStore } from "../../store/useResumeStore";


type ResumeData = {
  resumeUrl?: string;
  resumeFile?: File | null;
  portfolio?: string;
};

type Props = {
  onClose: () => void;
  setResume: (data: ResumeData[]) => void;
  defaultData: ResumeData[];
};

export default function EditResumeForm({ onClose, setResume, defaultData }: Props) {
  const [resumeFile, setResumeFile] = useState<File | null>(null);
  const [portfolio, setPortfolio] = useState(defaultData?.[0]?.portfolio || "");


  const { fetchCandidateProfile } = useCandidateProfileStore();
  const { updateResume, loading } = useResumeStore();


  const handleSave = async () => {
    const success = await updateResume({
      resumeFile,
      website: portfolio,
    });

    if (!success) return;

    const prev = defaultData?.[0];

    const updated = [
      {
        resumeUrl: resumeFile
          ? URL.createObjectURL(resumeFile) // preview
          : prev?.resumeUrl,
        resumeFile: resumeFile ?? prev?.resumeFile ?? null,
        portfolio,
      },
    ];
    fetchCandidateProfile();
    setResume(updated);
    onClose();
  };



  return (
    <div className="space-y-6 pb-4">
      <h3 className="text-lg font-semibold">Resume</h3>
      <p className="text-gray-500">
        Your profile is the first thing recruiters see and not your uploaded resume,
        so make sure your Talentlink profile is as complete and detailed as your uploaded resume
      </p>

      {resumeFile && (
        <p className="text-sm text-gray-500">
          Selected file: {resumeFile.name}
        </p>
      )}

      {defaultData?.[0]?.resumeUrl && !resumeFile && (
        <div className="text-sm text-gray-600 flex justify-between items-center border rounded-lg p-3">
          <span>
            Current resume:
            <a
              href={defaultData[0].resumeUrl}
              target="_blank"
              rel="noreferrer"
              className="text-primary font-semibold hover:underline"
            >
              View Resume
            </a>
          </span>


        </div>
      )}

      {/* Upload */}
      <label className="w-full border p-4 rounded-xl flex justify-between items-center cursor-pointer hover:bg-gray-50">
        <div>
          <span className="font-semibold text-primary">Select a file</span>
          <p className="text-xs text-gray-400">File Type PDF, File size max: 5 MB</p>
        </div>
        <input
          type="file"
          accept="application/pdf"
          className="hidden"
          onChange={(e) => setResumeFile(e.target.files?.[0] || null)}
        />
      </label>

      {/* Portfolio Link */}
      <input
        type="text"
        value={portfolio}
        onChange={(e) => setPortfolio(e.target.value)}
        placeholder="Portfolio Link"
        className="w-full border rounded-xl p-3"
      />

      {/* Buttons */}
      <div className="flex justify-center gap-4 pt-4">
        <button
          onClick={onClose}
          className="px-6 py-3 rounded-lg border text-gray-500 font-semibold"
        >
          Cancel
        </button>
        <button
          onClick={handleSave}
          className="px-6 py-3 rounded-lg bg-primary text-white font-semibold"
        >
          Save
        </button>
      </div>
    </div>
  );
}
